module.exports = __webpack_public_path__ + "fonts/remixicon.881fbc46.woff";